import { IIndexable } from 'core-ts-types';
import { ISelectable } from '../../global/servants/selection_list_servant';
import { ICategory } from '../../global/servants/hierarchy_category_servant';

export class Major implements ICategory, ISelectable, IIndexable {
  credits_applied: number = 0;
  credits_needed: number = 0;
  displayEarnedCredits: string = '0';
  additional_credits: number = 0;
  displayAdditionalCredits: string = '0';
  semesters_completed: number = 0;
  isSelected: boolean = false;
  isFound: boolean = false;
  category: string;
  description: string;
  created_ts?: string;
  about_text: string = '';
  title: string;
  sis_title?: string;
  nk: string;
  id: number;
  program_title: string;
  program_id?: number;
  degree_code: string;
  degree_title: string;
  major_code: string;
  major_title: string;
  concentration_code: string;
  concentration_title: string;
  displayTitle: string;
  searchOrdering: number = 0;
  auditAvailable: boolean = true;
  preprof_ind: boolean;
  isSuggested: boolean = false;
  degree_completion_percent?: number;
  degree_completion: number = 0;
  degree_completion_type: string = 'credit';
  cip_code: number;
  college_code?: string;
  has_about_text?: boolean;
  has_description?: boolean;
  is_visible?: boolean;
  sis_code?: string;
  ordering: number;

  static numberFilter: ng.IFilterNumber;
  static autoOrder: number = 0;

  constructor(major: Major) {
    _.merge(this, major);
    this.ordering = _.isNumber(major.ordering) ? major.ordering : Major.autoOrder++;
    this.displayTitle = Major.buildDisplayTitle(major);
    this.displayEarnedCredits = Major.numberFilter(Major.numberFilter(this.credits_applied, 2));
    this.displayAdditionalCredits = Major.numberFilter(Major.numberFilter(this.additional_credits, 2));
  }

  static buildDisplayTitle(major: Major): string {
    return major.title || major.program_title;
  }

  static build(major: any): Major {
    return new Major(major);
  }

  static merge(cached: Major, newType: any) {
    return new Major(_.merge(cached, newType));
  }
}

angular
  .module('capability-ng-transfer')
  .factory('ngMajorBuilder', function ngMajorBuilder(numberFilter: ng.IFilterNumber): typeof Major {
    Major.numberFilter = numberFilter;
    return Major;
  });



// WEBPACK FOOTER //
// ./app/lib/transfer/builders/major_builder.ts